import React__default from 'react';

var setInnerRef = function setInnerRef(ref, element) {
  if (ref && 'current' in ref) {
    var mutableRef = ref;
    mutableRef.current = element;
  } else if (typeof ref === 'function') {
    ref(element);
  }
}; // Accepts two refs that can be used on a single element via the returned ref function


var useCombinedRef = function useCombinedRef(firstRef, secondRef) {
  return React__default.useMemo(function () {
    if (!firstRef && !secondRef) {
      return null;
    }

    return function (element) {
      setInnerRef(firstRef, element);
      setInnerRef(secondRef, element);
    };
  }, [firstRef, secondRef]);
};

export { useCombinedRef };
